module.exports = __webpack_public_path__ + "static/seo-3878413705d3f3317b7b115ba3520383.jpg";